<template>
    <div class="card" :style="cardStyle">
        <div class="card-container">
            <div class="card-image">
                <div class="h-full w-full absolute top-0 l-0 bg-opacity-20 bg-black">
                    <div class="flex flex-col h-full p-4">
                        <div class="text-white border rounded-md text-xs h-fit px-1 py-0.5 w-fit">
                            {{ card.types.length ? card.types[0].name : '' }}
                        </div>
                        <div class="card-image-hover-title font-vectrex" :style="hoverTitleStyle()">
                            <p class="py-2">{{ card.name }}</p>
                        </div>
                        <div class="text-sm text-white mt-auto">
                            {{ formatDate(card.finishing_date) }}
                        </div>
                    </div>
                </div>
                <transition>
                    <img
                        draggable="false"
                        :src="card.cover && card.cover.cached_url"
                        class="object-cover h-full w-full max-w-none select-none"
                        :style="imageStyle()" alt="">
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import {formatDate} from "../../../utils/formatDate";

export default {
    props: {
        card: Object,
        stackPosition: Number,
        cardStyle: String,
        isCurrent: Boolean
    },
    data(){
        return {
            windowWidth: window.innerWidth,
        }
    },
    methods: {
        formatDate,
        imageStyle() {
            const baseWidth = window.innerWidth < 800 ? 200 : 280;
            const baseHeight = window.innerWidth < 800 ? 280 : 350;
            const reduction = 45;

            const width = baseWidth - this.stackPosition * reduction;
            const height = baseHeight - this.stackPosition * reduction;

            return `width: ${width}px; height: ${height}px; transition: width 1s, height 1s;`;
        },
        hoverTitleStyle(){
            if (this.stackPosition === 0){
                return "font-size: 2rem; max-height: 100px; overflow: hidden"
            }else if (this.stackPosition === 1){
                return "font-size: 1.75rem; max-height: 95px; overflow: hidden"
            } else {
                return "font-size: 1.5rem; max-height: 75px; overflow: hidden"
            }
        }
    }
};
</script>

<style scoped>
.card {
    @apply select-none absolute top-0 left-0 cursor-pointer;
    backface-visibility: visible;
    transform-style: preserve-3d;
    z-index: 999;
    transition-timing-function: cubic-bezier(0, 0, 0.23, 1);
    transition-duration: 0.8s;
}

.card-container {
    @apply select-none absolute top-0 left-0 block;
    backface-visibility: visible;
    transform-style: preserve-3d;
    transform: translateY(150px);
}

.card-image {
    @apply block rounded-lg box-border select-none absolute overflow-hidden relative;
    top: -150px;
    left: -150px;
    backface-visibility: visible;
    transform: translateY(-150px);
    max-width: inherit;
    background: white;
    box-shadow: 5px 5px 10px -2px rgba(0, 0, 0, 0.40);
}

.card-image-hover-title {
    @apply text-white leading-8 mt-12;
    transition: font-size 1s;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
